import axios from 'axios'
import {BUSCAR_RELATORIO_ITINERARIOS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import moment from 'moment';

export default function buscarRelatoriItinerarios(idEmpresa, dataInicio, dataFim, tipoConsulta) {
    const url = `${URL}/itinerario/empresa/${idEmpresa}/relatorio-itinerarios?dataInicio=${moment(dataInicio)
        .format('YYYY-MM-DD')}&dataFim=${moment(dataFim)
        .format('YYYY-MM-DD')}&tipoConsulta=${tipoConsulta}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_RELATORIO_ITINERARIOS,
            payload: response
        })
    );
}
